module.exports = __webpack_public_path__ + "static/media/usage-scroll.88b0e0d9.mp4";